import React from 'react';
import { FlameIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const perks = ['Accès numérique immédiat', 'Les 3 bonus inclus', 'Paiement unique', 'Jamais d’abonnement'];
export function FinalCta() {
  return <section className="w-full bg-ink py-20 text-white sm:py-28" data-id="element-52" data-mp="19cuo03h0uuop">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-53" data-mp="15caurazkkb7u">
        <p className="mb-5 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-sunshine" data-id="element-54" data-mp="1jcvce3tr00zr">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="1ed0li09z3bep" />
          Dernière chance — offre limitée
        </p>
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl md:text-5xl" data-id="element-56" data-mp="1t1n1m47fc76z">
          Vos enfants méritent de construire quelque chose de concret
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-57" data-mp="222uta3ffq9s3">
          Offrez-leur plus de 100 projets de robots, 3 bonus gratuits et des
          heures d’amusement sans écrans — le tout en un seul paiement simple.
        </p>
        <div className="mt-10" data-id="element-58" data-mp="n7ywt3r1xmqj">
          <CtaButton data-id="element-59" data-mp="s45u685dtpwv">Oui ! Je veux MakerLab maintenant</CtaButton>
        </div>
        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70" data-id="element-60" data-mp="x3s7ehl7n65o">
          {perks.map(p => <li key={p} className="flex items-center gap-1.5" data-id="element-61" data-mp="123mxwk12ptq7">
              <CheckIcon className="h-4 w-4 text-sunshine" aria-hidden="true" data-id="element-62" data-mp="164qamxntr9n7" />
              {p}
            </li>)}
        </ul>
      </div>
    </section>;
}